<template>
    <div class="container-fluid mtb15 no-fluid">
        <div class="row sm-gutters">
            <!-- Menu -->
            <div v-if="1200 < getWindowsWidth" class="col-sm-12 col-md-2">
                <AppMenu></AppMenu>
            </div>
            <!-- exchange breakdown -->
            <div v-if="'ExchangeBreakdown' === currentVuewName" class="col-sm-12"
                :class="{'col-md-10' : 1200 < getWindowsWidth }">
                <div class="row align-items-center wallet-detail-header">
                    <div class="col-sm-1 wallet-detail-back">
                        <button class="btn btn-outline-secondary btn-light mb-2"
                            :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }"
                            @click.prevent="goBack()">&larr;</button>
                    </div>
                    <div class="col-sm-11 text-left wallet-detail-title">
                        <h5>{{ labels.positions }} - {{ getExchangeName }}</h5>
                    </div>
                </div>
                <WalletExchangeBreakdownSummary
                    :exchange-id="selectedItemExchangeId"
                    :window-width="getWindowsWidth"
                    :labels="labels"
                    :currency="getCurrency"
                    :exchange-currency="getExchangeCurrency"
                    :equities-value="getExchangeEquitiesValue"
                    :equities-value-in-base-currency="getExchangeEquitiesValueInBaseCurrency"
                    :equities-value-in-exchange-currency="getExchangeEquitiesValueInExchangeCurrency"
                    :average-equities-value="getExchangeAverageEquitiesValue"
                    :average-equities-value-in-base-currency="getExchangeAverageEquitiesValueInBaseCurrency"
                    :positions-count="getExchangePositionsCount"
                    :shares-count="getExchangeSharesCount"
                    :all-exchanges-equities-value="getAllExchangesEquitiesAsMoneyDefaultCurrency"
                    :total-balance="totalBalance"
                    :format-price="formatPrice"
                    :parse-number="parseNumber"
                />
                <WalletExchangePositionsList
                    :stocks="getExchangeAvailableStocks"
                    :window-width="getWindowsWidth"
                    :user-language="getUserLanguage"
                    :labels="labels"
                    :stock-type-resolver="getStockType"
                    :positions-amount-resolver="getPositionsAmount"
                    :trade-purchase-price-resolver="getTradePurchasePrice"
                    :trade-market-price-resolver="getTradeMarketPrice"
                    :percent-diff-resolver="getPercentDiff"
                    :format-price="formatPrice"
                    :parse-number="parseNumber"
                    @open-trades="openTradesList"
                    @open-details="openInstrumentDetails"
                />
            </div>
            <div v-if="'ActivityDetails' === currentVuewName" class="col-sm-12 col-md-10">
                <!-- header -->
                <div class="row align-items-center wallet-detail-header">
                    <div class="col-sm-1 wallet-detail-back">
                        <!-- back button -->
                        <button class="btn btn-outline-secondary btn-light mb-2"
                            :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }"
                            @click.prevent="currentVuewName = 'ExchangeBreakdown'">&larr;</button>
                    </div>
                    <div class="col-sm-11 text-left wallet-detail-title">
                        <!-- view header -->
                        <h5 v-if="1200 < getWindowsWidth">{{ labels.positions }} - {{ getExchangeName }} - {{
                            selectedItem?.sc }}, {{ 0 === 'BG'.localeCompare(getUserLanguage) && selectedItem?.nBG ?
                            selectedItem?.nBG : selectedItem?.nEN }} - {{ activityTabLabel }}</h5>
                        <h6 v-else>{{ labels.positions }} - ... - {{ activityTabLabel }}</h6>
                    </div>
                </div>
                <div class="row sm-gutters">
                    <div class="col-sm-12 col-md-2">
                        <ul class="nav nav-tabs nav-pills settings-nav position-activity-tabs mb-3">
                            <li class="nav-item" v-for="tab in activityTabs" :key="tab.key">
                                <button
                                    type="button"
                                    class="nav-link"
                                    :class="{ active: activityTab === tab.key }"
                                    @click.prevent="activityTab = tab.key"
                                >{{ tab.label }}</button>
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-12 col-md-10">
                        <WalletExchangeInstrumentDetails
                            v-if="'Information' === activityTab && !selectedInstrumentIsOff"
                            :item="selectedItem"
                            :window-width="getWindowsWidth"
                            :user-language="getUserLanguage"
                            :exchange-name="getExchangeName"
                            :labels="labels"
                            :all-exchanges-equities-value="getAllExchangesEquitiesAsMoneyDefaultCurrency"
                            :stock-type-resolver="getStockType"
                            :positions-amount-resolver="getPositionsAmount"
                            :trade-purchase-price-resolver="getTradePurchasePrice"
                            :trade-market-price-resolver="getTradeMarketPrice"
                            :percent-diff-resolver="getPercentDiff"
                            :format-price="formatPrice"
                            :parse-number="parseNumber"
                        />
                        <div v-if="'Information' === activityTab && selectedInstrumentIsOff" class="instrument-not-traded-message">
                            {{ labels.instrumentNoLongerTraded }}
                        </div>
                        <WalletExchangeTradesList
                            v-if="'Trades' === activityTab"
                            :trades="getFilteredTrades"
                            :trade-list-orders="tradeListOrders"
                            :window-width="getWindowsWidth"
                            :user-language="getUserLanguage"
                            :labels="labels"
                            :date-resolver="getDate"
                            :purchase-type-resolver="getPurchaseType"
                            :order-type-resolver="getOrderType"
                            :order-status-resolver="getOrderStatus"
                            :trade-total-amount-resolver="getTradeTotalAmount"
                            :capitalize-first-letter="capitalizeFirstLetter"
                            :format-price="formatPrice"
                            :parse-number="parseNumber"
                            @open-trade-details="openTradeDetails"
                        />
                        <div v-if="'Transfers' === activityTab && !transfersLoaded" class="trade-details-loading">
                            <Preloader />
                        </div>
                        <WalletExchangeTransfersList
                            v-if="'Transfers' === activityTab && transfersLoaded"
                            :transfers="getFilteredTransfers"
                            :window-width="getWindowsWidth"
                            :user-language="getUserLanguage"
                            :labels="labels"
                            :date-resolver="getDate"
                            :transfer-type-resolver="getTransferType"
                            :capitalize-first-letter="capitalizeFirstLetter"
                            :format-price="formatPrice"
                            :parse-number="parseNumber"
                            @open-transfer-details="openTransferDetails"
                        />
                    </div>
                </div>
            </div>
            <div v-if="'TradeDetails' === currentVuewName" class="col-sm-12 col-md-10">
                <!-- header -->
                <div class="row align-items-center wallet-detail-header">
                    <div class="col-sm-1 wallet-detail-back">
                        <!-- back button -->
                        <button class="btn btn-outline-secondary btn-light mb-2"
                            :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }"
                            @click.prevent="currentVuewName = 'ActivityDetails'; activityTab = 'Trades'">&larr;</button>
                    </div>
                    <div class="col-sm-11 text-left wallet-detail-title">
                        <!-- view header -->
                        <h5 v-if="1200 < getWindowsWidth">{{ labels.positions }} - {{ getExchangeName }} - {{
                            selectedItem?.sc }}, {{ 0 === 'BG'.localeCompare(getUserLanguage) && selectedItem?.nBG ?
                            selectedItem?.nBG : selectedItem?.nEN }} - {{ labels.trades }} - #{{ trade?.oid }}</h5>
                        <h6 v-else>{{ labels.positions }} - ... - #{{ trade?.oid }}</h6>
                    </div>
                </div>
                <div v-if="tradeDetailsLoading" class="trade-details-loading">
                    <Preloader />
                </div>
                <WalletExchangeTradeDetails
                    v-else
                    :trade="trade"
                    :trade-list-orders="tradeListOrders"
                    :window-width="getWindowsWidth"
                    :user-language="getUserLanguage"
                    :labels="labels"
                    :date-resolver="getDate"
                    :order-type-resolver="getOrderType"
                    :trade-total-amount-resolver="getTradeTotalAmount"
                    :format-price="formatPrice"
                />
            </div>
            <div v-if="'TransferDetails' === currentVuewName" class="col-sm-12 col-md-10">
                <div class="row align-items-center wallet-detail-header">
                    <div class="col-sm-1 wallet-detail-back">
                        <button class="btn btn-outline-secondary btn-light mb-2"
                            :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }"
                            @click.prevent="currentVuewName = 'ActivityDetails'; activityTab = 'Transfers'">&larr;</button>
                    </div>
                    <div class="col-sm-11 text-left wallet-detail-title">
                        <h5 v-if="1200 < getWindowsWidth">{{ labels.positions }} - {{ getExchangeName }} - {{
                            selectedItem?.sc }}, {{ 0 === 'BG'.localeCompare(getUserLanguage) && selectedItem?.nBG ?
                            selectedItem?.nBG : selectedItem?.nEN }} - {{ labels.transfers }}</h5>
                        <h6 v-else>{{ labels.positions }} - ... - {{ labels.transfers }}</h6>
                    </div>
                </div>
                <WalletExchangeTransferDetails
                    :transfer="transfer"
                    :window-width="getWindowsWidth"
                    :user-language="getUserLanguage"
                    :labels="labels"
                    :date-resolver="getDate"
                    :transfer-type-resolver="getTransferType"
                    :stock-type-resolver="getStockType"
                    :format-price="formatPrice"
                    :parse-number="parseNumber"
                />
            </div>
            <div v-if="'InstrumentDetails' === currentVuewName" class="col-sm-12 col-md-10">
                <div class="row align-items-center wallet-detail-header">
                    <div class="col-sm-1 wallet-detail-back">
                        <button class="btn btn-outline-secondary btn-light mb-2"
                            :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }"
                            @click.prevent="currentVuewName = 'ExchangeBreakdown'">&larr;</button>
                    </div>
                    <div class="col-sm-11 text-left wallet-detail-title">
                        <h5 v-if="1200 < getWindowsWidth">{{ labels.positions }} - {{ getExchangeName }} - {{
                            selectedItem?.sc }}, {{ 0 === 'BG'.localeCompare(getUserLanguage) && selectedItem?.nBG ?
                            selectedItem?.nBG : selectedItem?.nEN }} - {{ labels.information }}</h5>
                        <h6 v-else>{{ labels.positions }} - ... - {{ labels.information }}</h6>
                    </div>
                </div>
                <WalletExchangeInstrumentDetails
                    v-if="!selectedInstrumentIsOff"
                    :item="selectedItem"
                    :window-width="getWindowsWidth"
                    :user-language="getUserLanguage"
                    :exchange-name="getExchangeName"
                    :labels="labels"
                    :all-exchanges-equities-value="getAllExchangesEquitiesAsMoneyDefaultCurrency"
                    :stock-type-resolver="getStockType"
                    :positions-amount-resolver="getPositionsAmount"
                    :trade-purchase-price-resolver="getTradePurchasePrice"
                    :trade-market-price-resolver="getTradeMarketPrice"
                    :percent-diff-resolver="getPercentDiff"
                    :format-price="formatPrice"
                    :parse-number="parseNumber"
                />
                <div v-else class="instrument-not-traded-message">
                    {{ labels.instrumentNoLongerTraded }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppMenu from '@/components/ui/AppMenu.vue';
import Preloader from "@/components/ui/Preloader.vue";
import UiUtils from "@/assets/js/ui_utils.js";
import I18n from "@/lang/i18n.js";
import WalletExchangeBreakdownSummary from "@/features/wallet/components/WalletExchangeBreakdownSummary.vue";
import WalletExchangeInstrumentDetails from "@/features/wallet/components/WalletExchangeInstrumentDetails.vue";
import WalletExchangePositionsList from "@/features/wallet/components/WalletExchangePositionsList.vue";
import WalletExchangeTradeDetails from "@/features/wallet/components/WalletExchangeTradeDetails.vue";
import WalletExchangeTradesList from "@/features/wallet/components/WalletExchangeTradesList.vue";
import WalletExchangeTransferDetails from "@/features/wallet/components/WalletExchangeTransferDetails.vue";
import WalletExchangeTransfersList from "@/features/wallet/components/WalletExchangeTransfersList.vue";
import { fetchTrades, fetchTransfers } from "@/features/wallet/wallet-api";
import {
    getAllExchangeEquitiesValue,
    getExchangeCodeById,
    getExchangeCurrencyById,
    getExchangeEquitiesAverageValue,
    getExchangeEquitiesValue,
    getExchangePositionsCount,
    getExchangeSharesCount,
    getStocksByExchangeCode
} from "@/features/wallet/wallet-exchange-metrics";
import {
    getExchangeStockTrades,
    getTradeOrderById,
    preloadTradeOrders as preloadExchangeTradeOrders
} from "@/features/wallet/wallet-exchange-trades";
import { getStockTypeLabel } from "@/features/stocks/stock-type-labels";
import { getOrderActionLabel, getOrderStatusLabel, getPurchaseTypeLabel, getTransferTypeLabel } from "@/features/wallet/wallet-label-formatters";
import { getTotalAssetsValue } from "@/features/wallet/wallet-portfolio-metrics";
import { sortTransfersBySelection } from "@/features/wallet/wallet-list-utils";

// Defensive JSON parsing: some parents may pass props later or as undefined.
// Keep the view resilient and avoid runtime crashes.

export default {
    components: {
        AppMenu,
        Preloader,
        WalletExchangeBreakdownSummary,
        WalletExchangeInstrumentDetails,
        WalletExchangePositionsList,
        WalletExchangeTradeDetails,
        WalletExchangeTradesList,
        WalletExchangeTransferDetails,
        WalletExchangeTransfersList
    },
    data() {
        return {
            selectedItemExchangeId: parseInt(this.exchangeId || '0'),
            selectedItem: null,
            currentVuewName: "ExchangeBreakdown",
            trade: null,
            transfer: null,
            activityTab: "Trades",
            transfers: [],
            transfersLoaded: false,
            transfersRequest: null,
            tradesLoaded: false,
            tradesRequest: null,
            tradeDetailsLoading: false,
            tradeListOrders: [],
            orderRequests: {}
        }
    },
    props: {
        exchangeId: {
            type: String,
            required: true
        }
    },
    methods: {
        t(key, ...args) {
            return I18n.t(key, this.getUserLanguage, ...args);
        },
        formatPrice(val, curr, autoDigits = 2) {
            return UiUtils.formatPrice(val, curr, this.getUserLanguage, autoDigits);
        },
        parseNumber(num, afterDot = 2) {
            return UiUtils.formatNumber(num, afterDot);
        },
        capitalizeFirstLetter(string) {
            return string
                ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
                : "";
        },
        getStockType(typeId) {
            return getStockTypeLabel(typeId, this.labels);
        },
        getDate(unix) {
            return UiUtils.parseUnixTime(unix);
        },
        getOrderType(ot) {
            return getOrderActionLabel(ot, this.labels);
        },
        getPurchaseType(type) {
            return getPurchaseTypeLabel(type, this.labels);
        },
        getTransferType(type) {
            return getTransferTypeLabel(type, this.labels);
        },        
        async getOrderById(orderId) {
            return getTradeOrderById({
                orderId,
                orders: this.tradeListOrders,
                requests: this.orderRequests,
                userType: this.$store.getters["getUserType"],
                user: this.$store.getters["getUser"]
            });
        },
        preloadTradeOrders(trades) {
            preloadExchangeTradeOrders({
                trades,
                orders: this.tradeListOrders,
                requests: this.orderRequests,
                userType: this.$store.getters["getUserType"],
                user: this.$store.getters["getUser"]
            });
        },
        getOrderStatus(order) {
            return getOrderStatusLabel(order, this.labels);
        },
        goBack() {
            const latestActiveMenuSelection =
                typeof this.$route.query.latestActiveMenuSelection === "string"
                    ? this.$route.query.latestActiveMenuSelection
                    : "Equities";

            this.$router.push({
                name: "Wallet",
                query: { latestActiveMenuSelection }
            });
        },
        async ensureTransfersLoaded() {
            if (this.transfersLoaded || this.transfersRequest) {
                return this.transfersRequest;
            }
            if (0 === parseInt(this.$store.getters["getUserType"])) {
                this.transfersLoaded = true;
                return null;
            }

            const user = this.$store.getters["getUser"];
            const today = new Date().toISOString().slice(0, 10);
            this.transfersRequest = fetchTransfers(this.$store.getters["getUserType"], user, "1970-01-01", today)
                .then(res => {
                    if (0 === res?.data?.ec) {
                        this.transfers = Array.isArray(res.data.stocks) ? res.data.stocks : [];
                    }
                    this.transfersLoaded = true;
                })
                .catch(err => {
                    console.error(err);
                    this.transfersLoaded = true;
                })
                .finally(() => {
                    this.transfersRequest = null;
                });
            return this.transfersRequest;
        },
        async ensureTradesLoaded() {
            if (this.tradesLoaded || this.tradesRequest) {
                return this.tradesRequest;
            }

            const user = this.$store.getters["getUser"];
            const today = new Date().toISOString().slice(0, 10);
            this.tradesRequest = fetchTrades(this.$store.getters["getUserType"], user, "1970-01-01", today)
                .then(res => {
                    if (0 === res?.data?.ec) {
                        this.$store.commit("wallet/setTrades", Array.isArray(res.data.stocks) ? res.data.stocks : []);
                    }
                    this.tradesLoaded = true;
                })
                .catch(err => {
                    console.error(err);
                    this.tradesLoaded = true;
                })
                .finally(() => {
                    this.tradesRequest = null;
                });
            return this.tradesRequest;
        },
        openTradesList(stock) {
            this.selectedItem = stock;
            this.activityTab = "Information";
            this.currentVuewName = 'ActivityDetails';
            this.$nextTick(() => this.preloadTradeOrders(this.getFilteredTrades));
            this.ensureTradesLoaded();
            this.ensureTransfersLoaded();
        },
        openInstrumentDetails(stock) {
            this.selectedItem = stock;
            this.currentVuewName = 'InstrumentDetails';
        },
        async openTradeDetails(transaction) {
            this.currentVuewName = 'TradeDetails';
            this.tradeDetailsLoading = true;
            try {
                await this.ensureTradesLoaded();
                this.trade = this.enrichTradeFromStore(transaction);
                await this.getOrderById(this.trade?.oid);
            } finally {
                this.tradeDetailsLoading = false;
            }
        },
        openTransferDetails(transaction) {
            this.transfer = transaction;
            this.currentVuewName = 'TransferDetails';
        },
        withSelectedInstrumentData(item, selected) {
            return {
                ...item,
                sc: item.sc ?? selected?.sc,
                cc: item.cc ?? selected?.cc,
                xc: item.xc ?? item.ex ?? selected?.ex,
                sgm: item.sgm ?? item.segment ?? selected?.sgm,
                nEN: item.nEN ?? selected?.nEN,
                nBG: item.nBG ?? selected?.nBG,
                stid: item.stid ?? selected?.stid
            };
        },
        uniqueBy(items, keyResolver) {
            const seen = new Set();
            return items.filter(item => {
                const key = keyResolver(item);
                if (seen.has(key)) {
                    return false;
                }
                seen.add(key);
                return true;
            });
        },
        enrichTradeFromStore(transaction) {
            const orderId = transaction?.oid?.toString();
            if (!orderId) {
                return transaction;
            }

            const storedTrade = this.$store.getters["wallet/tradeById"]?.(orderId);
            return storedTrade
                ? {
                    ...transaction,
                    ...storedTrade
                }
                : transaction;
        },
        getPercentDiff(marketPrice, avgPrice) {
            const diff = parseFloat(marketPrice) - parseFloat(avgPrice);
            return parseFloat(diff) / parseFloat(avgPrice) * 100;
        }, 
        getTradePurchasePrice(item) {
            const stocks = this.$store.getters["getStocks"];
            const indexedStocks = this.$store.getters["getIndexedStocks"];

            return UiUtils.getTradePurchasePrice(stocks, indexedStocks, item);
        },
        getTradeMarketPrice(item) {
            const stocks = this.$store.getters["getStocks"];
            const indexedStocks = this.$store.getters["getIndexedStocks"];

            return UiUtils.getTradeMarketPrice(stocks, indexedStocks, item);
        },
        getTradeTotalAmount(item) {
            const stocks = this.$store.getters["getStocks"];
            const indexedStocks = this.$store.getters["getIndexedStocks"];

            return UiUtils.getTradeTotalAmountValue(stocks, indexedStocks, item);
        },
        getPositionsAmount(item) {
            const stocks = this.$store.getters["getStocks"];
            const indexedStocks = this.$store.getters["getIndexedStocks"];

            return UiUtils.getPositionsAmount(stocks, indexedStocks, item);
        }
    },
    watch: {
        getFilteredTrades(trades) {
            this.preloadTradeOrders(trades);
        }
    },
    computed: {
        getWindowsWidth() {
            return this.$store.getters["getAppWindowWidth"] || window.innerWidth;
        },          
        getUserLanguage() {
            return this.$store.getters["getNonLoggedInLanguage"]?.toUpperCase() || "EN";
        },
        exchangeCode() {
            const exchanges = this.$store.getters["getExchanges"];
            return getExchangeCodeById(exchanges, this.selectedItemExchangeId);
        },
        labels() {
            return {
                amount: this.t("amountLabel"),
                averagePrice: this.t("averagePriceLabel"),
                balance: this.t("balanceLabel"),
                baseCurrency: this.t("baseCurrencyLabel"),
                bonds: this.t("bondsLabel"),
                buy: this.t("buyLabel"),
                cancelled: this.t("cancelledLabel"),
                cfd: this.t("cfdLabel"),
                code: this.t("codeLabel"),
                compInstruments: this.t("compInstrumentsLabel"),
                currency: this.t("currencyLabel"),
                equities: this.t("equitiesLabel"),
                exchange: this.t("exchangeLabel"),
                fee: this.t("feeLabel"),
                faceValue: this.t("faceValueLabel"),
                filled: this.t("filledLabel"),
                funds: this.t("fundsLabel"),
                information: this.t("informationLabel"),
                incoming: this.t("incomingLabel"),
                instrumentType: this.t("instrumentTypeLabel"),
                instrumentNoLongerTraded: this.t("instrumentNoLongerTradedMessage"),
                noTransfersForInstrument: this.t("noTransfersForInstrumentMessage"),
                instruments: this.t("instrumentsLabel"),
                limit: this.t("limitLabel"),
                margin: this.t("marginLabel"),
                market: this.t("marketLabel"),
                marketPrice: this.t("marketPriceLabel"),
                myPositions: this.t("myPositionsLabel"),
                name: this.t("nameLabel"),
                netting: this.t("nettingLabel"),
                numberOfShares: this.t("numberOfSharesLabel"),
                orderId: this.t("orderLabel"),
                orderType: this.t("orderTypeLabel"),
                outgoing: this.t("outgoingLabel"),
                placed: this.t("placedLabel"),
                position: this.t("positionLabel"),
                portfolio: this.t("portfolioLabel"),
                positions: this.t("positionsLabel"),
                positionsBalance: this.t("positionsPercentageLabel"),
                positionsPercentage: this.t("positionsPercentageLabel"),
                price: this.t("priceLabel"),
                processing: this.t("processingLabel"),
                purchasePrice: this.t("purchasePriceLabel"),
                quantity: this.t("quantityLabel"),
                reits: this.t("reitsLabel"),
                repo: this.t("repoLabel"),
                return: this.t("returnLabel"),
                rights: this.t("rightsLabel"),
                sell: this.t("sellLabel"),
                stockCode: this.t("codeLabel"),
                stockName: this.t("nameLabel"),
                stocksAndEtfs: this.t("stocksAndEtfsLabel"),
                segment: this.t("segmentLabel"),
                status: this.t("statusLabel"),
                timestamp: this.t("timestampLabel"),
                totalAmount: this.t("totalAmountLabel"),
                totalBalance: this.t("balancePercentageLabel"),
                other: this.t("othersLabel"),
                tradeId: this.t("tradeIdLabel"),
                transfers: this.t("transfersMenuItem"),
                trades: this.t("tradesLabel"),
                type: this.t("typeLabel"),
                value: this.t("valueLabel")
            };
        },
        getExchangeCurrency() {
            const exchanges = this.$store.getters["getExchanges"];
            return getExchangeCurrencyById(exchanges, this.selectedItemExchangeId);
        },
        getCurrency() {
            return this.$store.getters["getCurrency"].toUpperCase();
        },
        getExchangeEquitiesValue() {
            const userWallet = this.$store.getters["getWallet"];
            const stocks = this.$store.getters["getStocks"];
            const indexedStocks = this.$store.getters["getIndexedStocks"];

            return getExchangeEquitiesValue({
                stocks,
                indexedStocks,
                wallet: userWallet,
                exchangeCode: this.exchangeCode,
                currency: this.getExchangeCurrency
            });
        },
        getExchangeEquitiesValueInBaseCurrency() {
            const userWallet = this.$store.getters["getWallet"];
            const stocks = this.$store.getters["getStocks"];
            const indexedStocks = this.$store.getters["getIndexedStocks"];

            return getExchangeEquitiesValue({
                stocks,
                indexedStocks,
                wallet: userWallet,
                exchangeCode: this.exchangeCode,
                currency: this.getCurrency
            });
        },        
        getExchangeEquitiesValueInExchangeCurrency() {
            const userWallet = this.$store.getters["getWallet"];
            const stocks = this.$store.getters["getStocks"];
            const indexedStocks = this.$store.getters["getIndexedStocks"];

            return getExchangeEquitiesValue({
                stocks,
                indexedStocks,
                wallet: userWallet,
                exchangeCode: this.exchangeCode,
                currency: this.getExchangeCurrency
            });
        },        
        getExchangeAverageEquitiesValue() {
            const userWallet = this.$store.getters["getWallet"];
            const stocks = this.$store.getters["getStocks"];
            const indexedStocks = this.$store.getters["getIndexedStocks"];

            return getExchangeEquitiesAverageValue({
                stocks,
                indexedStocks,
                wallet: userWallet,
                exchangeCode: this.exchangeCode,
                currency: this.getExchangeCurrency
            });
        },
        getExchangeAverageEquitiesValueInBaseCurrency() {
            const userWallet = this.$store.getters["getWallet"];
            const stocks = this.$store.getters["getStocks"];
            const indexedStocks = this.$store.getters["getIndexedStocks"];

            return getExchangeEquitiesAverageValue({
                stocks,
                indexedStocks,
                wallet: userWallet,
                exchangeCode: this.exchangeCode,
                currency: this.getCurrency
            });
        },        
        totalAssetsValue() {
            const userWallet = this.$store.getters["getWallet"];
            return getTotalAssetsValue({
                wallet: userWallet,
                currency: this.getCurrency
            });
        },
        totalBalance() {
            return (parseFloat(this.getAllExchangesEquitiesAsMoneyDefaultCurrency) + parseFloat(this.totalAssetsValue));
        },
        getExchangePositionsCount() {
            const userWallet = this.$store.getters["getWallet"];
            return getExchangePositionsCount(userWallet, this.exchangeCode);
        },          
        getExchangeSharesCount() {
            const userWallet = this.$store.getters["getWallet"];
            return getExchangeSharesCount(userWallet, this.exchangeCode);
        },        
        getAllExchangesEquitiesAsMoneyDefaultCurrency() {
            const userWallet = this.$store.getters["getWallet"];
            const stocks = this.$store.getters["getStocks"];
            const indexedStocks = this.$store.getters["getIndexedStocks"];

            return getAllExchangeEquitiesValue({
                stocks,
                indexedStocks,
                wallet: userWallet,
                currency: this.getCurrency
            });
        },        
        getExchangeAvailableStocks() {
            const wallet = this.$store.getters["getWallet"];
            return getStocksByExchangeCode(wallet, this.exchangeCode);
        },
        getFilteredTrades() {
            const wallet = this.$store.getters["getWallet"];

            return getExchangeStockTrades({
                wallet,
                selectedItem: this.selectedItem,
                exchangeCode: this.exchangeCode
            });
        },
        getFilteredTransfers() {
            const selectedStockCode = this.selectedItem?.sc?.toString().toLowerCase();
            const selectedExchange = this.exchangeCode?.toString().toLowerCase();
            const fetchedTransfers = this.transfers.filter(item => {
                const transferStockCode = item?.sc?.toString().toLowerCase();
                const transferExchange = item?.xc?.toString().toLowerCase() || item?.ex?.toString().toLowerCase();
                return selectedStockCode === transferStockCode
                    && (!selectedExchange || selectedExchange === transferExchange);
            }).map(item => this.withSelectedInstrumentData(item, this.selectedItem));
            return sortTransfersBySelection(this.uniqueBy(fetchedTransfers, transfer => [
                transfer.ts,
                transfer.qty,
                transfer.sp,
                transfer.pt,
                transfer.tt,
                transfer.sc,
                transfer.xc
            ].join("|")), 1);
        },
        activityTabs() {
            return [
                { key: "Information", label: this.labels.information },
                { key: "Trades", label: this.labels.trades },
                { key: "Transfers", label: this.labels.transfers }
            ];
        },
        activityTabLabel() {
            return this.activityTabs.find(tab => tab.key === this.activityTab)?.label || "";
        },
        selectedInstrumentIsOff() {
            const selected = this.selectedItem;
            if (!selected) {
                return false;
            }

            const selectedCode = selected.sc?.toString().toUpperCase();
            const selectedExchange = (selected.xc ?? selected.ex)?.toString().toUpperCase();
            const isMatchingInstrument = trade => {
                const tradeCode = trade?.sc?.toString().toUpperCase();
                const tradeExchange = (trade?.xc ?? trade?.ex)?.toString().toUpperCase();
                return selectedCode === tradeCode && (!selectedExchange || selectedExchange === tradeExchange);
            };

            return selected.off === true
                || (selected.t || []).some(trade => trade?.off === true)
                || (this.$store.getters["wallet/trades"] || []).some(trade => trade?.off === true && isMatchingInstrument(trade));
        },
        getExchangeName() {
            return this.exchangeCode || "";
        }
    }
}
</script>

<style scoped>
  .wallet-detail-header {
    flex-wrap: nowrap;
  }

  .wallet-detail-back {
    flex: 0 0 auto;
    width: auto;
  }

  .wallet-detail-title {
    flex: 1 1 auto;
    width: auto;
  }

  .wallet-detail-title h5,
  .wallet-detail-title h6 {
    margin-bottom: 0.5rem;
  }

  .xsmall-font-size {
    font-size: x-small;
  }

  .position-activity-tabs {
    box-shadow: 0 0 15px #00000012;
    display: block;
    padding: 0.5rem;
  }

  .position-activity-tabs .nav-link {
    border: 0;
    border-radius: 0.25rem;
    color: #000b3c;
    font-weight: 600;
    margin-bottom: 0.25rem;
    text-align: left;
    width: 100%;
  }

  .position-activity-tabs .nav-link.active {
    background-color: #0088aa;
    color: #fff;
  }

  .trade-details-loading {
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: calc(100vh - 8rem);
    width: 100%;
  }

  .trade-details-loading :deep(.hollow-dots-spinner) {
    transform: scale(2);
  }

  .instrument-not-traded-message {
    font-size: 1rem;
    padding: 1rem;
  }
</style>

